import _objectSpread from "@babel/runtime/helpers/esm/objectSpread2";
import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime/helpers/esm/createClass";
import _inherits from "@babel/runtime/helpers/esm/inherits";
import _createSuper from "@babel/runtime/helpers/esm/createSuper";
import React, { Component } from 'react';
import { SVGIcon } from '@instructure/ui-svg-images';

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M1411.824,2.84217094e-14 C1442.995,2.84217094e-14 1468.294,25.299 1468.294,56.471 L1468.294,56.471 L1468.294,112.941 L1637.706,112.941 C1731.11,112.941 1807.118,188.951 1807.118,282.353 L1807.118,282.353 L1807.118,1920 L113,1920 L113,282.353 C113,188.951 189.009,112.941 282.412,112.941 L282.412,112.941 L451.823,112.941 L451.823,56.471 C451.823,25.299 477.123,2.84217094e-14 508.294,2.84217094e-14 C539.466,2.84217094e-14 564.765,25.299 564.765,56.471 L564.765,56.471 L564.765,112.941 L1355.354,112.941 L1355.354,56.471 C1355.354,25.299 1380.653,2.84217094e-14 1411.824,2.84217094e-14 Z M1581.237,1242.354 L1242.414,1242.354 L1242.414,1581.177 L1581.237,1581.177 L1581.237,1242.354 Z M1129.471,1242.354 L790.647,1242.354 L790.647,1581.177 L1129.471,1581.177 L1129.471,1242.354 Z M677.706,1242.354 L338.882,1242.354 L338.882,1581.177 L677.706,1581.177 L677.706,1242.354 Z M1581.237,790.588 L1242.414,790.588 L1242.414,1129.412 L1581.237,1129.412 L1581.237,790.588 Z M1129.471,790.588 L790.647,790.588 L790.647,1129.412 L1129.471,1129.412 L1129.471,790.588 Z M677.706,790.588 L338.882,790.588 L338.882,1129.412 L677.706,1129.412 L677.706,790.588 Z M451.823,225.882 L282.412,225.882 C251.353,225.882 225.942,251.181 225.942,282.353 L225.942,282.353 L225.942,451.765 L1694.176,451.765 L1694.176,282.353 C1694.176,251.181 1668.765,225.882 1637.706,225.882 L1637.706,225.882 L1468.294,225.882 L1468.294,282.353 C1468.294,313.525 1442.995,338.824 1411.824,338.824 C1380.653,338.824 1355.354,313.525 1355.354,282.353 L1355.354,282.353 L1355.354,225.882 L564.765,225.882 L564.765,282.353 C564.765,313.525 539.466,338.824 508.294,338.824 C477.123,338.824 451.823,313.525 451.823,282.353 L451.823,282.353 L451.823,225.882 Z",
  fillRule: "evenodd",
  stroke: "none",
  strokeWidth: "1"
});

var IconCalendarMonthSolid = /*#__PURE__*/function (_Component) {
  _inherits(IconCalendarMonthSolid, _Component);

  var _super = _createSuper(IconCalendarMonthSolid);

  function IconCalendarMonthSolid() {
    _classCallCheck(this, IconCalendarMonthSolid);

    return _super.apply(this, arguments);
  }

  _createClass(IconCalendarMonthSolid, [{
    key: "render",
    value: function render() {
      return /*#__PURE__*/React.createElement(SVGIcon, Object.assign({}, this.props, {
        name: "IconCalendarMonth",
        viewBox: "0 0 1920 1920"
      }), _ref);
    }
  }]);

  IconCalendarMonthSolid.displayName = "IconCalendarMonthSolid";
  return IconCalendarMonthSolid;
}(Component);

IconCalendarMonthSolid.glyphName = 'calendar-month';
IconCalendarMonthSolid.variant = 'Solid';
IconCalendarMonthSolid.propTypes = _objectSpread({}, SVGIcon.propTypes);
export default IconCalendarMonthSolid;
export { IconCalendarMonthSolid };